import { CSLayoutProps, CSPageHeaderProps } from "types";

import PageHeaderRight from "components/shared/header/PageHeaderRight";
import React from "react";
import { isNullOrUndefOrEmpty } from "@civicscience/chops";

type useLayoutFactoryProps = CSLayoutProps & {
  classNamePrefix?: string;
  asDocTitle?: boolean;
};

const useLayoutFactory = ({
  id,
  classNamePrefix = "",
  pageDescription,
  containerFluid = "xl",
  asDocTitle = true,
  children,
  headerProps,
  headerRightChildren,
  titleBottomChildren,
  titleSuperscriptChildren,
  errorMessageProps,
  successMessageProps,
  infoMessageProps,
}: useLayoutFactoryProps) => {
  const hasError = !isNullOrUndefOrEmpty(errorMessageProps);
  const hasSuccess = !isNullOrUndefOrEmpty(successMessageProps);
  const hasInfo = !isNullOrUndefOrEmpty(infoMessageProps);
  const hasHeaderChildrenRight = !isNullOrUndefOrEmpty(headerRightChildren);
  const hasChildren = !isNullOrUndefOrEmpty(children);

  const pageHeaderProps = {
    id: isNullOrUndefOrEmpty(id) ? undefined : `${id}-page-header`,
    containerFluid,
    asDocTitle,
    headerRightChildren: hasHeaderChildrenRight ? <PageHeaderRight>{headerRightChildren}</PageHeaderRight> : null,
    titleBottomChildren: !isNullOrUndefOrEmpty(pageDescription) ? (
      <p className={`${classNamePrefix}-description`}>{pageDescription}</p>
    ) : (
      titleBottomChildren
    ),
    titleClassName: `${classNamePrefix}-title`,
    titleSuperscriptChildren,
    ...headerProps,
  } as CSPageHeaderProps;

  const hasHeader = !isNullOrUndefOrEmpty(pageHeaderProps.title);

  return {
    hasError,
    hasSuccess,
    hasInfo,
    hasHeader,
    hasChildren,
    hasHeaderChildrenRight,
    pageHeaderProps,
  };
};

export default useLayoutFactory;
